import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'shared/api-client';
import * as v from 'valibot';

import type { AnalyticsBatchingConfig } from './analytics/unified.ts';

const AnalyticsBatchingSchema = v.object({
  enabled: v.fallback(v.boolean(), false),
  flushIntervalMs: v.fallback(v.pipe(v.number(), v.minValue(0)), 2000),
  maxBatchSize: v.fallback(v.pipe(v.number(), v.integer(), v.minValue(1)), 20),
});

const FlagsSchema = v.object({
  tiktokInAppGateKValues: v.fallback(v.array(v.string()), []),
  analyticsBatching: v.fallback(
    AnalyticsBatchingSchema,
    v.getFallbacks(AnalyticsBatchingSchema) as AnalyticsBatchingConfig,
  ),
});

type Flags = {
  tiktokInAppGateKValues: readonly string[];
  analyticsBatching: AnalyticsBatchingConfig;
};

const getFlagsRequest = async (): Promise<Flags> => {
  try {
    const res = await apiClient.get('kv_store/api/data/flags/').json();
    return v.parse(FlagsSchema, res);
  } catch {
    return v.getFallbacks(FlagsSchema);
  }
};

export const flagsQuery = () =>
  queryOptions({
    queryKey: ['flags'],
    queryFn: () => getFlagsRequest(),
    staleTime: Infinity,
    gcTime: Infinity,
  });
